import '@corbieres/scss/app.scss';
import '@corbieres/scss/app-editor.scss';
import '@corbieres/scss/app-print.scss';
import '@corbieres/js/bootstrap.bundle';
import Utils from '@corbieres/js/services/utils';
import Form from '@corbieres/js/services/form';
import Map from '@corbieres/js/services/map';
import Weather from '@corbieres/js/services/weather';
import Slider from '@corbieres/js/services/slider';
import Menu from '@corbieres/js/services/menu';
import Roadtrip from '@corbieres/js/services/roadtrip';

document.addEventListener( "DOMContentLoaded", function () {
    new Utils();
    new Form();
    new Map();
    new Weather();
    new Slider();
    new Menu();
    new Roadtrip();
})
